import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { Carousel } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { ModuleCarouselProps } from '../types'
import Media from './_Media'

export const ModuleCarousel: React.FC<ModuleCarouselProps> = ({ video, images, moduleSlug }) => {
  const validImages = images.filter((img): img is { url: string } => Boolean(img.url))

  const carouselItems: { url: string }[] = []

  if (video) {
    carouselItems.push({ url: video })
  }

  carouselItems.push(...validImages)

  if (carouselItems.length === 0) {
    return null
  }

  return (
    <>
      <Box paddingBottom="s32">
        <Text size="300" weight="semibold" color="black">
          {i18n.t('marketplace.revamp.overview')}
        </Text>
      </Box>
      <Carousel
        columns={{
          lg: 2,
          md: 2,
          sm: 1,
          xl: 2,
          xs: 1,
        }}
        showPeek
        delay={5000}
      >
        {carouselItems.map((item, index) => (
          <Box key={index}>
            <Media
              video={item}
              thumbnail={{ src: item.url }}
              title={undefined}
              autoPlay
              moduleSlug={moduleSlug}
            />
          </Box>
        ))}
      </Carousel>
    </>
  )
}
